// extracted by mini-css-extract-plugin
module.exports = {"file-info":"file-info-box_component_file-info__RgOhy","value-container":"file-info-box_component_value-container__1IwW6","column":"file-info-box_component_column__msGiW"};